module.exports = __webpack_public_path__ + "img/logo-_1.519b108f.svg";